import axiosIns from "@/api/axios";

export const GET_LIST = (params) => {
  return axiosIns.get(`/wake-up-call?${params}`);
};

export const DETAIL = (id) => {
  return axiosIns.get(`/wake-up-call/${id}`);
};

export const RECIPIENT_LIST = (params) => {
  return axiosIns.get(`/wake-up-call-recipient?${params}`);
};

export const CREATE = (body) => {
  return axiosIns.post("/wake-up-call", body, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export const UPDATE = (body) => {
  return axiosIns.put(`/wake-up-call`, body, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export const DELETE = (id) => {
  return axiosIns.delete(`/wake-up-call/${id}`);
};